import {
  bindMiniAppCssVars,
  bindThemeParamsCssVars,
  bindViewportCssVars,
  miniApp,
  themeParams,
  viewport,
} from '@telegram-apps/sdk-react'

export function mountTheme(): void {
  themeParams.mountSync.ifAvailable()
  bindThemeParamsCssVars.ifAvailable()

  miniApp.mountSync.ifAvailable()
  bindMiniAppCssVars.ifAvailable()
}

export async function mountViewport(): Promise<void> {
  const [mounting, promise] = viewport.mount.ifAvailable()

  if (mounting) {
    // Awaited, but not fatally: a client that refuses to report its viewport
    // still shows an app, it just does not get --tg-viewport-* to size against.
    try {
      await promise
    } catch {
      return
    }
  }

  bindViewportCssVars.ifAvailable()
  viewport.expand.ifAvailable()
}

export function applyColorScheme(dark: boolean): void {
  document.documentElement.dataset['theme'] = dark ? 'dark' : 'light'
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light'
}
